import React from "react"
import GalleryLink from "../../chat/SlickAIGalleryLink"
import { ImageBlock } from "./types"

export const ImageRenderer = ({
  block,
  messageId,
}: {
  block: ImageBlock
  messageId: string
}) => {
  return (
    <div className="my-4 flex justify-center">
      <GalleryLink href={block.url} messageId={messageId}>
        <img
          src={block.url}
          className="max-w-full rounded-md shadow-sm transition-shadow hover:shadow-md"
        />
      </GalleryLink>
    </div>
  )
}
